import React from 'react';
import useTitle from '../../../hook/useTitle';
import Banner from '../Banner/Banner';
import Galary from '../Galary/Galary';
import HomeServices from '../HomeServices/HomeServices';

const Home = () => {
    useTitle('Home')
    return (
        <div>
            <Banner></Banner>
            <HomeServices></HomeServices>
            <Galary></Galary>
        </div>

    );
};

export default Home;